// Tailwind-aware classname merger. Every UI primitive imports `cn`
// from this module so a stray `className` prop reliably wins over
// the component's defaults (`twMerge` resolves Tailwind conflicts).

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
